
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1800 1100"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#fff","d":"M0 0h1800v1100H0z"}}),_c('path',{attrs:{"fill":"#003580","d":"M0 400h1800v300H0z"}}),_c('path',{attrs:{"fill":"#003580","d":"M500 0h300v1100H500z"}})])
          )
        }
      }
    